import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsMessagesPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/messages.js